<template>
    <div
        class="cabinet-settings-documents__item"
        :class="{
            'cabinet-settings-documents__item--done': doc.length > 0
        }"
    >
        <div class="cabinet-settings-documents__item-title subtitle2 flex">
            {{ title }}
        </div>
        <div class="cabinet-settings-documents__item-note">{{ note }}</div>
        <div
            v-if="loading == name"
            class="cabinet-settings-documents__item-loader spinning-loader"
        ></div>
        <div v-else>
            <label
                v-if="doc.length == 0"
                class="custom-file-upload subtitle2 mt-16"
            >
                <input
                    type="file"
                    accept=".jpg,.rtf,.png,.doc,.docx,.pdf,.jpeg"
                    @change="sendFile(name, title, $event)"
                />
                Загрузить
            </label>
            <div
                v-else
                class="cabinet-settings-documents__item-info flex flex-align-center"
            >
                {{ doc[0].original_filename }}
                <div class="cabinet-settings-documents__item-icons">
                    <a
                        :href="`${doc[0].filename}`"
                        download
                        target="_blank"
                        class="cabinet-settings-documents__item-icon"
                    >
                        <img src="/img/icons/download.svg" alt="" />
                    </a>
                    <a
                        href="javascript:void(0)"
                        class="cabinet-settings-documents__item-icon"
                        @click="removeDocumentWrapper(doc[0])"
                    >
                        <img src="/img/icons/delete.svg" alt="" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DocsItem',
    props: {
        doc: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        note: {
            type: String,
            required: false
        },
        name: {
            type: String,
            required: true
        },
        loading: {
            type: String,
            required: true
        }
    },
    computed: {
        APP_URL() {
            return process.env.VUE_APP_URL_APP
        }
    },
    methods: {
        removeDocumentWrapper(document) {
            this.$emit('removeDocument', document)
        },
        sendFile(name, title, event) {
            let sendFileContent = {
                name: name,
                title: title,
                event: event,
                type: this.name
            }
            this.$emit('sendDocument', sendFileContent)
        }
    }
}
</script>
